module.exports = __webpack_public_path__ + "img/lotuss-logo.79f6875a.png";